<template>
    <div class="advertising" :class="{visible: isvisible}">
        <div class="ad-container">
            <div class="slide" v-for="(slide, index) in slides" :class="{ active: slide.isActive }" :id="'slide'+slide.index">
                <img :src="slide.file.url" v-if="slide.file.type == 'image'">
                <video :src="slide.file.url" v-if="slide.file.type == 'video'" :id="'vid'+slide.file.id+'_'+index" muted></video>
            </div>
        </div>

    </div>

</template>

<script>
import axios from "axios";

export default {
    name: 'Advertising',
    props: ['options', 'store'],
    data: function () {
        return {
            slides: [],
            currentSlide: 0,
            advertising: []
        }
    },
    created() {
        let v = this;

        this.multiplyAdvertising();

        this.advertising.forEach(function (el, index) {
            el.isActive = false;
            el.index = index;
            if (el.file){
                v.slides.push(el)
            }

        })
        this.slides[0].isActive = true;
        this.saveToDatabase(this.slides[0]);
        this.loadNext()

    },
    computed: {
        isvisible(){
            let portrait = ( window.innerHeight > window.innerWidth ) ? true : false;
            if ( portrait && this.$route.name === 'Home' ){
                return true
            } else if ( portrait ){
                return false
            } else {
                return true
            }
        }
    },
    methods: {
        loadNext(){
            let v = this;
            let nextIndex;
            let slide = this.slides[this.currentSlide];
            if ( this.currentSlide < this.slides.length - 1 ){
                nextIndex = this.currentSlide + 1;
            } else {
                nextIndex = 0;
            }
            let wait = slide.dauer * 1000;
            if ( slide.file.type === 'video' ){
                wait = 50;
            }

            if ( slide.file.type === 'image' ){
                setTimeout(function () {
                    v.showSlide(nextIndex);
                }, wait)
            } else {
                v.showSlide(nextIndex)
            }

        },
        showSlide(index){
            let v = this;
            let newslides = v.slides.filter(x=> x);
            newslides.forEach(x=> x.isActive = false);
            newslides[index].isActive = true;
            v.slides = newslides;
            v.currentSlide = index;
            let slide = this.slides[this.currentSlide];

            if (slide.file.type === 'image'){
                v.loadNext();
            }

            if ( slide.file.type === 'video' ){
                var slide_element = document.getElementById('slide'+slide.index);
                var vid = slide_element.querySelector('video');
                vid.removeEventListener('ended', v.loadNext);
                vid.addEventListener('ended', v.loadNext)
                setTimeout( function (){
                    vid.play()
                } , 500 )
                // vid.play();
            }
            this.saveToDatabase(slide);

        },
        saveToDatabase(slide ){

            if (this.$route.name != 'ShopDetails' && this.$route.name != 'Services' && this.isvisible){

                let data = {
                    id: slide.file.id,
                    duration: parseInt(slide.dauer),
                    filename: slide.file.filename,
                    location: this.options.location,
                    werbeinhalt: slide.werbeinhalt,
                    kunde: slide.kunde,
                    kampagne: slide.kampagne,
                    sonstiges: slide.sonstiges,
                    spotlange: slide.spotlange,
                }

                if ( slide.file.type === 'video' ){
                    data.duration = 0
                }

                // console.log (slide.file.filename)

                if ( window.location.href.indexOf('shoppingcityseiersberg.at') > 0 ){
                    axios.post(
                        'https://www.shoppingcityseiersberg.at/wp-json/rubikon/v1/advertising',
                        data
                    ).then(response => {

                    }, error => {
                        // console.log('axios error' + error)
                    });
                } else {
                    // console.log('Not logging advertising. Not running on live server')
                }


            }
        },
        multiplyAdvertising(){
            let v = this
            let undistributedArray = [];

            this.store.advertising.forEach(function (el, key) {
                for (let i=0; i < el.multiplikator; i++ ){
                    // console.log(i);
                    if ( i > 0 ){
                        el['duplicate'] = true
                        undistributedArray.push({
                            file: el.file,
                            name: el.file.name,
                            duplicate: el.duplicate,
                            dauer: el.dauer,
                            tage: el.tage,
                            multiplikator: el.multiplikator,
                            id: i,
                            originkey: key
                        } )
                    } else {
                        el['duplicate'] = false
                    }
                    // console.log(el['duplicate'])

                }
                v.advertising.push(el);
            })
            // console.log('adlength: '+ v.advertising.length)
            // console.log(undistributedArray)

            let advertisinglength = v.advertising.length;
            let totalLength = undistributedArray.length + v.advertising.length;
            undistributedArray.forEach(function (el, key) {
                // console.log('element:'+el.file.name);
                let frequency = ~~(totalLength / el.multiplikator);
                // calculated position
                let pos = frequency *(el.id) + ~~(el.originkey) ;

                //wrap around if pos greater than array length
                if (pos > advertisinglength){
                    pos = pos % advertisinglength;
                }
                // console.log('original pos:'+el.originkey)
                // console.log('frequenct:'+frequency)
                // console.log('inserting into pos:' + pos);
                v.advertising.splice(pos, 0, el);

            })

        }

    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
@import "src/styles/variables";

.advertising {
    width: 580px;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    padding-left: 115px;
    position: absolute;
    height: 881px;
    opacity: 0;
    visibility: hidden;

    &.visible {
        opacity: 1;
        visibility: visible;
    }

    @include portrait(){
        width: auto;
        bottom: 90px;
        transform: scale(1.3);
        transform-origin: bottom left;
        left: -107px;
    }

    .ad-container {
        padding: 20px;
        background: white;
        width: 447px;
        height: 772px;
        max-height: 100%;
        border: 2px solid #BFBFBF;
        overflow: hidden;
        display: flex;
        justify-content: center;
        align-items: center;
    }

    .slide {
        max-width: 100%;
        display: none;
        &.active {
            display: block;
        }
        img, video {
            max-width: 100%;
        }
    }

    @include portrait(){
        display: none;
    }

    img {
        max-height: 90%;
    }

}
</style>
